import { Box, Typography } from '@mui/material';
import { PricebookBundle } from '../../../models/PricebookData';
import AccentBar from '../../rev-share/components/AccentBar';
import PricebookRestrictionCard from './PricebookRestrictionCard';

interface PricebookRestrictionSectionProps {
  title: string;
  accentColor: string;
  pricebooks: PricebookBundle[];
  addOnPricebookLookup: Map<number, PricebookBundle>;
  inUsePricebookIds: Set<number>;
  isInheritMode: boolean;
  selectedPricebookIds: Set<number>;
  onTogglePricebook: (pricebookId: number) => void;
}

const PricebookRestrictionSection: React.FC<PricebookRestrictionSectionProps> = ({
  title,
  accentColor,
  pricebooks,
  addOnPricebookLookup,
  inUsePricebookIds,
  isInheritMode,
  selectedPricebookIds,
  onTogglePricebook,
}) => {
  if (!pricebooks.length) return null;

  return (
    <Box display='flex' flexDirection='column' rowGap='10px'>
      <Box display='flex' alignItems='center' columnGap='10px' mb='5px'>
        <AccentBar color={accentColor} />
        <Typography variant='p16SemiBold' color='secondary.main'>
          {title}
        </Typography>
      </Box>
      <Box
        display='grid'
        gridTemplateColumns='repeat(2, 1fr)'
        gridAutoRows='1fr'
        columnGap='20px'
        rowGap='15px'>
        {pricebooks.map(pb => {
          const pricebookInUse = inUsePricebookIds.has(pb.pricebook.id);
          const isReadOnly = isInheritMode;
          return (
            <PricebookRestrictionCard
              key={pb.pricebook.id}
              pricebookBundle={pb}
              addOnPricebook={addOnPricebookLookup.get(pb.pricebook.id)}
              selected={isInheritMode || selectedPricebookIds.has(pb.pricebook.id)}
              readOnly={isReadOnly}
              inUse={pricebookInUse}
              onToggle={() => onTogglePricebook(pb.pricebook.id)}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default PricebookRestrictionSection;
